<template>
  <div class="transport">

    <div class="data-row transport-actions-row">
      <transport-action-menu
        :visitor='visitor'
        :transport='transport'
        :cfg-menu-visitor='cfgMenuVisitor'
        :cfg-menu-transport='cfgMenuTransport'
        @issue-pass="$emit('issue-pass', transport)"
        @change-transport-access="(transport) => $emit('change-transport-access', transport)"
        @give-pdf-pass="(isGivePassPeriod, printPermanentAsOne) => $emit('give-pdf-pass', isGivePassPeriod, printPermanentAsOne)"
      />
    </div>

    <div class="transport-view-row">

      <div class="vertical-field transport-center-field">

        <div class='field-label'>
          {{ fieldTitle(TransportSectionFieldAliases.TYPE_INPUT) }}
        </div>

        <div class='data-row transport-type-gap'>

          <img :src="transportTypeIcon" alt="" class='transport-type-icon'>

          <div>{{ transport.typeName }}</div>

        </div>

      </div>

      <div class="vertical-field transport-center-field">

        <div class='field-label'>
          {{ fieldTitle(TransportSectionFieldAliases.MARK) }}
        </div>

        <div>{{ transport.mark }}</div>

      </div>

      <div class="vertical-field transport-center-field">

        <div class='field-label'>
          {{ fieldTitle(TransportSectionFieldAliases.MODEL) }}
        </div>

        <div>{{ transport.model }}</div>

      </div>

    </div>

    <div class="horizontal-field">

      <div class="field-label">
        {{ fieldTitle(TransportSectionFieldAliases.COLOR) }}:
      </div>

      <div>{{ transport.color }}</div>

    </div>

    <div class="horizontal-field">

      <div class="field-label">
        {{ fieldTitle(TransportSectionFieldAliases.OWNER) }}:
      </div>

      <div>{{ transport.owner }}</div>

    </div>

  </div>
</template>

<script>
import applicationViewMixin from '../../../mixins/application-view/applicationViewMixin';
import { TransportSectionFieldAliases } from '../../../enums/TransportSectionFieldAliases';
import TransportActionMenu from './menu/TransportActionMenu.vue';
export default {

  mixins: [applicationViewMixin],

  components: { TransportActionMenu },

  emits: ['toggle-transport'],

  props: {
    transport: {
      type: Object
    },

    visitor: {
      type: Object
    },

    baseUrl: {
      type: String
    },

    cfgFormFields: {
      type: Object,
      required: true
    },

    cfgMenuVisitor: {
      type: Object
    },

    cfgMenuTransport: {
      type: Object
    }
  },

  computed: {
    TransportSectionFieldAliases() {
      return TransportSectionFieldAliases
    },

    transportTypeIcon() {
      return `${this.baseUrl}/img/icons/${this.transport.type}.png`
    }
  }
}
</script>

<style>
.transport {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.transport-active {
  background-color: rgba(51, 122, 183, 0.1);
}

.transport-center-field {
  align-items: center;
}

.transport-view-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.transport-type-gap {
  gap: 8px;
}

.transport-type-icon {
  height: 16px;
}

.transport-actions-row {
  justify-content: end;
}
</style>
